import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ChangeStudiesOptionRegisterView from './ChangeStudiesOptionRegisterView';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as modalityOptionListActions } from '../../../../../../../domain/useCases/procedures/getModalityOptionList';
import { Creators as registerActions } from '../../../../../../../domain/useCases/procedures/registerChangeRequest/registerUseCase';

import routes from '../../../../../../components/Routes/routingMap';

const ChangeStudiesOptionRegisterViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedOption, setSelectedOption] = React.useState<any>(null);
  const [confirmRequest, setConfirmRequest] = React.useState(false);
  const [selectedPeriod, setSelectedPeriod] = React.useState<any>(null);
  const [optionsList, setOptionsList] = React.useState<any>(null);
  const [isEnrolled, setIsInrolled] = React.useState(false);
  const [isRequestLimit, setIsRequestLimit] = React.useState(false);
  const [listCourses, setListCourses] = React.useState<any>([]);
  const [isRequestLimitAndEnrollment, setIsRequestLimitAndEnrollment] =
    React.useState(false);
  const [selectedCampusData, setSelectedCampusData] = React.useState<any>(null);
  const [turnList, setTurnList] = React.useState<any>(null);
  const [selectedTurn, setSelectedTurn] = React.useState<any>(null);

  const { procedure: procedureSelectedInfo, isLoading } = useSelector(
    (state: any) => state.procedureInformation
  );
  useEffect(() => {
    if (!procedureSelectedInfo) {
      history.push('/tramites');
    }
  }, [procedureSelectedInfo]);

  const {
    data: dataModalityOptionList,
    isLoading: isLoadingModalityOptionList
  } = useSelector((state: any) => state.modalityOptionList);

  const validateProcedureInfo = () => {
    if (
      procedureSelectedInfo.error ||
      procedureSelectedInfo.disabled === true ||
      procedureSelectedInfo.currentRequestId !== 0
    ) {
      history.push('/tramites');
    }
  };
  const {
    requestId,
    isLoading: isLoadingRegister,
    isSuccess: isRegisterSuccess,
    error: isRegisterError
  } = useSelector((state: any) => state.registerChange);

  const handlerRequest = () => {
    // if (procedureSelectedInfo.error) {
    //   setProcessAvailable(true);
    //   return;
    // }

    if (
      procedureSelectedInfo?.requestLimit &&
      procedureSelectedInfo?.enrollment
    ) {
      setListCourses(
        procedureSelectedInfo?.enrolledCourses
          ? procedureSelectedInfo?.enrolledCourses
          : []
      );
      setIsRequestLimitAndEnrollment(true);
      return;
    }

    if (procedureSelectedInfo?.requestLimit) {
      setIsRequestLimit(true);
      return;
    }

    if (procedureSelectedInfo?.enrollment) {
      setListCourses(
        procedureSelectedInfo?.enrolledCourses
          ? procedureSelectedInfo?.enrolledCourses
          : []
      );
      if (procedureSelectedInfo?.enrolledCourses?.length < 1) {
        setIsInrolled(false);
        setConfirmRequest(true);
      } else {
        setIsInrolled(true);
      }

      return;
    }

    setConfirmRequest(true);
  };

  const handleCloseModalIsInrolledAndRequestLimit = () => {
    setIsRequestLimitAndEnrollment(false);
    setConfirmRequest(true);
  };

  const handleCloseModalIsInrolled = () => {
    setIsInrolled(false);
    setConfirmRequest(true);
  };

  const handleCloseModalIsRequestLimit = () => {
    setIsRequestLimit(false);
    setConfirmRequest(true);
  };
  const handlerSendData = () => {
    const dataModalityPlanGrado = dataModalityOptionList.find(
      (e: any) => e.id === selectedOption.value
    );
    const campus = procedureSelectedInfo?.detail?.campusApplied;
    dispatch(
      registerActions.registerChange(
        1031,
        selectedOption?.value, // id de la modalidad
        selectedOption?.label, // descripcion de la modalidad
        selectedPeriod?.value, // periodo de la modalidad
        campus.length > 1
          ? selectedCampusData?.value
          : dataModalityPlanGrado?.campus,
        // valor del campus ---> LIMAN
        dataModalityPlanGrado?.grado, // grado asignado
        dataModalityPlanGrado?.plan, // plan asignado
        dataModalityPlanGrado?.period,
        selectedTurn?.value,
        selectedTurn?.label
        // falta agregar el id del turno seleccionado es un string targetShift
      )
    );
  };

  useEffect(() => {
    if (requestId > 0 && isRegisterSuccess) {
      dispatch(requestStatusActions.getStudentProcedureStatus(1031, requestId));
      history.push(
        routes.student.procedures.categories.requests.changeStudiesOption
          .procedureprogress
      );
    }
  }, [isRegisterSuccess]);

  const handlerCloseModalConfirmRequest = () => {
    setConfirmRequest(false);
  };

  React.useEffect(() => {
    if (!procedureSelectedInfo && !isLoading) {
      dispatch(procedureActions.getProcedureInformation(1031));
    }
  }, []);

  React.useEffect(() => {
    if (procedureSelectedInfo) validateProcedureInfo();
  }, [procedureSelectedInfo]);

  const handlerChangeOption = (option: any) => {
    setSelectedOption(option);
    const turnsFilter = dataModalityOptionList?.find(
      (e: any) => option.value === e.id
    );
    setSelectedTurn(null);
    setTurnList(turnsFilter?.shifts);
  };

  const handlerChangePeriod = (period: any) => {
    if (period?.value) {
      const campus = procedureSelectedInfo?.detail?.campusApplied;
      dispatch(
        modalityOptionListActions.getModalityOptionList(
          campus.length > 1 ? selectedCampusData?.value : campus[0].id,
          parseInt(period?.value, 10)
        )
      );
      setSelectedPeriod(period);
      setSelectedOption(null);
      setSelectedTurn(null);
      setOptionsList(dataModalityOptionList);
    }

    // const list: any[] = procedureSelectedInfo?.detail?.studiesOptionList;
    // const lis1 = list.filter((p) => p.tag === '');
    // const lis2 = list.filter((p) => p.tag.includes(period?.value));
    // const lis3 = [...lis1, ...lis2];
    // setOptionsList(lis3);
    // setSelectedPeriod(period);
    // setSelectedOption(null);
    // code
  };

  useEffect(() => {
    if (dataModalityOptionList) {
      setOptionsList(dataModalityOptionList);
    }
  }, [dataModalityOptionList]);

  const handlerChangeCampus = (campus: any) => {
    setSelectedCampusData(campus);
    setSelectedPeriod(null);
    setSelectedOption(null);
    setSelectedTurn(null);
  };

  const handlerChangeCycle = (option: any) => {
    if (option?.value) {
      setSelectedTurn(option);
    }
  };

  const handlerErrorClose = () => {
    dispatch(registerActions.registerChangeClear());
  };

  return (
    <ChangeStudiesOptionRegisterView
      procedureSelectedInfo={procedureSelectedInfo}
      isProcessing={isLoadingRegister}
      handlerChangeOption={handlerChangeOption}
      selectedOption={selectedOption}
      handlerRequest={handlerRequest}
      confirmRequest={confirmRequest}
      setConfirmRequest={setConfirmRequest}
      handlerCloseModalConfirmRequest={handlerCloseModalConfirmRequest}
      handlerSendData={handlerSendData}
      handlerChangePeriod={handlerChangePeriod}
      selectedPeriod={selectedPeriod}
      optionsList={optionsList}
      isEnrolled={isEnrolled}
      handleCloseModalIsInrolled={handleCloseModalIsInrolled}
      listCourses={listCourses}
      handleCloseModalIsRequestLimit={handleCloseModalIsRequestLimit}
      isRequestLimit={isRequestLimit}
      handleCloseModalIsInrolledAndRequestLimit={
        handleCloseModalIsInrolledAndRequestLimit
      }
      isRequestLimitAndEnrollment={isRequestLimitAndEnrollment}
      handlerChangeCampus={handlerChangeCampus}
      selectedCampusData={selectedCampusData}
      isLoadingModalityOptionList={isLoadingModalityOptionList}
      handlerChangeCycle={handlerChangeCycle}
      turnList={turnList}
      selectedTurn={selectedTurn}
      isEntering={procedureSelectedInfo?.isEntering}
      isRegisterError={isRegisterError}
      handlerErrorClose={handlerErrorClose}
    />
  );
};

export default ChangeStudiesOptionRegisterViewController;
